import Encoding from 'encoding-japanese';
import { stripBom } from './csvParse';

function isUtf8(bytes: Uint8Array): boolean {
  try {
    new TextDecoder('utf-8', { fatal: true }).decode(bytes);
    return true;
  } catch {
    return false;
  }
}

/**
 * Excel "CSV UTF-8" is UTF-8 (often with BOM). Excel "CSV (comma delimited)"
 * on Japanese Windows is Shift_JIS, which is not valid UTF-8. Decode before
 * parsing so the server always receives a Unicode string.
 */
export function decodeCsvBytes(bytes: Uint8Array): string {
  if (bytes.length === 0) return '';
  if (isUtf8(bytes)) {
    return stripBom(new TextDecoder('utf-8').decode(bytes));
  }
  const detected = Encoding.detect(bytes);
  const from = detected === 'SJIS' || detected === 'UNICODE' ? detected : 'SJIS';
  const unicode = Encoding.convert(bytes, { to: 'UNICODE', from });
  return stripBom(Encoding.codeToString(unicode));
}

export async function decodeCsvFile(file: File): Promise<string> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  return decodeCsvBytes(bytes);
}
